import React from 'react';
import { Layout, Typography, Card, Row, Col } from 'antd';

const { Content } = Layout;
const { Title, Paragraph } = Typography;

const appDevelopmentServices = [
    {
        title: 'AI-Powered Applications',
        description: 'Leverage cutting-edge AI and machine learning to build intelligent applications that automate and optimize business processes.',
    },
    {
        title: 'Web & Mobile Development',
        description: 'Develop high-performance web and mobile applications with seamless user experiences, scalability, and security.',
    },
    {
        title: 'Enterprise Software Solutions',
        description: 'Design and develop enterprise-grade software tailored to your business needs, from CRM to ERP solutions.',
    },
    {
        title: 'Custom AI Chatbots',
        description: 'Enhance customer interactions with intelligent AI-driven chatbots for support, sales, and automation.',
    },
    {
        title: 'Cloud-Native Applications',
        description: 'Build cloud-native applications that are scalable, resilient, and optimized for cloud infrastructure.',
    },
    {
        title: 'API Development & Integration',
        description: 'Create and integrate APIs to enable seamless data exchange between different systems and platforms.',
    },
    {
        title: 'Cybersecurity & Compliance',
        description: 'Implement secure development practices to ensure compliance with industry standards and data protection regulations.',
    },
    {
        title: 'Full-Stack Development',
        description: 'Develop end-to-end applications with robust front-end and back-end architectures for dynamic user experiences.',
    },
];

function ApplicationDevelopment() {
    return (
        <Layout>
            <Content style={{ padding: '50px' }}>
                <Title level={2}>Application Development</Title>
                <Paragraph>
                    JectHub specializes in building cutting-edge applications that leverage AI, cloud, and modern software development principles. 
                    Whether you need a web app, mobile solution, or enterprise software, our team delivers scalable, secure, and high-performance applications.
                </Paragraph>
                <Row gutter={[16, 16]}>
                    {appDevelopmentServices.slice(0, 4).map((service, index) => (
                        <Col xs={24} sm={12} md={12} lg={6} key={index}>
                            <Card title={service.title} bordered={false}>
                                <Paragraph>{service.description}</Paragraph>
                            </Card>
                        </Col>
                    ))}
                </Row>
                <hr style={{ margin: '40px 0' }} />
                <Row gutter={[16, 16]}>
                    {appDevelopmentServices.slice(4, 8).map((service, index) => (
                        <Col xs={24} sm={12} md={12} lg={6} key={index}>
                            <Card title={service.title} bordered={false}>
                                <Paragraph>{service.description}</Paragraph>
                            </Card>
                        </Col>
                    ))}
                </Row>
            </Content>
        </Layout>
    );
}

export default ApplicationDevelopment;
